export default {
  lang: "Français",

  // Dextra Content
  welcome: "Consultation vidéo Dextra",
  s_services: "Services Dextra",
  s_tracking: "Suivi des services",
  s_record: "Services de documents",
  s_redirect: "Redirection de service",
  s_adress: "Services d'adresse",
  s_feedback: "Support client",
  privacy: "Votre vie privée est importante. Les conversations sont traitées confidentiellement et ne sont pas enregistrées.",
  agentAvailability: "Disponibilité de l'agent",
  available: "Disponible",
  unavailable: "Indisponible",
  connecting_title: "Connexion...",
  connecting_message: "Veuillez patienter un moment.",
  cancel: "Annuler",
  button_start: "Commencer ici"
}
